import { schema } from 'normalizr';

export const hometownGroupSchema = new schema.Entity('hometownGroup', {}, { idAttribute: 'id' });
export const hometownGroupListSchema = [hometownGroupSchema];
